"use client";

import { c as _c } from "react/compiler-runtime";
import { FlagProvider } from "@unleash/nextjs";
import { UNLEASH_APP_NAME, UNLEASH_ENVIRONMENT, UNLEASH_FRONTEND_API_TOKEN, UNLEASH_FRONTEND_API_URL } from "@/constants/unleash";
export function FlagsProvider(t0) {
  const $ = _c(6);
  const {
    children,
    toggles,
    config
  } = t0;
  let t1;
  if ($[0] !== config || $[1] !== toggles) {
    t1 = {
      url: UNLEASH_FRONTEND_API_URL,
      appName: UNLEASH_APP_NAME,
      clientKey: UNLEASH_FRONTEND_API_TOKEN,
      environment: UNLEASH_ENVIRONMENT,
      bootstrap: toggles,
      ...config
    };
    $[0] = config;
    $[1] = toggles;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== t1) {
    t2 = <FlagProvider config={t1} startClient={false}>{children}</FlagProvider>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}